import { useEffect, useLayoutEffect, useMemo } from "react";
import { View } from "react-native";
import type { BottomTabNavigationProp } from "@react-navigation/bottom-tabs";
import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useLocale } from "@src/packages/i18n";
import type { AccessStackParamList, MainTabParamList } from "../../types";
import { ProgramDetailContent } from "../../components/ProgramDetailSheet";
import { getFactSheetRouteBlock } from "../../components/factSheetRouteIds";
import { useSmartBack } from "../../hooks/useSmartBack";

type Props = NativeStackScreenProps<AccessStackParamList, "ProgramDetail">;

export default function ProgramDetailScreen({ route, navigation }: Props) {
  const { programId, returnTab } = route.params;
  const { locale } = useLocale();
  const rootNavigation =
    navigation.getParent<BottomTabNavigationProp<MainTabParamList>>();
  const handleBack = useSmartBack({
    returnTab,
    fallbackTab: "Access",
    fallbackScreen: "Programs",
  });

  const item = useMemo(() => {
    void locale;
    return getFactSheetRouteBlock("program", programId);
  }, [programId, locale]);

  useEffect(() => {
    if (!item) {
      navigation.goBack();
    }
  }, [item, navigation]);

  useLayoutEffect(() => {
    if (item) {
      navigation.setOptions({ title: item.title });
    }
  }, [item, navigation]);

  if (!item) return null;

  return (
    <View style={{ flex: 1 }}>
      <ProgramDetailContent
        item={item}
        onClose={handleBack}
        onOpenProcedure={(procedureId) =>
          rootNavigation?.navigate("Learn", {
            screen: "ProcedureDetail",
            params: { procedureId, returnTab: "Access" },
          })
        }
        onOpenTest={(testId) =>
          rootNavigation?.navigate("Access", {
            screen: "TestDetail",
            params: { testId },
          })
        }
        skipExitAnimation
      />
    </View>
  );
}
